export default "__VITE_ASSET__26bf221d__"